import { useDispatch } from 'react-redux';
import FJMobileCreationViewContainer from '../FJMainPreview/FJMobileCreationView/FJMobileCreationViewContainer';
import FJMobileHistoryContainer from '../FJMainPreview/FJMobileHistory/FJMobileHistoryContainer';
import FJMobileImageToImageEditContainer from './FJMobileImageToImageEdit/FJMobileImageToImageEditContainer';
import FJMobileImageToImagePresetContainer from './FJMobileImageToImagePreset/FJMobileImageToImagePresetContainer';
import { useEffect } from 'react';
import FJActionImageToImage from '../../redux/action/FJActionImageToImage';
const FJMobileImageToImage = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(FJActionImageToImage.loadImageToImagePageAction());
    }, [dispatch]);

    return (
        <>
            <FJMobileImageToImagePresetContainer />
            <FJMobileCreationViewContainer />
            <FJMobileImageToImageEditContainer />
            <FJMobileHistoryContainer />
        </>
    );
};
export default FJMobileImageToImage;
